
import { Head } from '@inertiajs/react'
import { useState } from 'react'
import { Button } from "@/components/ui/button"

// import cs from './InertiaExample.module.css'

import { AppSidebar } from "@/components/app-sidebar"
import { ChartAreaInteractive } from "@/components/chart-area-interactive"
import { DataTable } from "@/components/data-table"
import { SectionCards } from "@/components/section-cards"
import { SiteHeader } from "@/components/site-header"
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar"

import data from "@/dashboard/data.json"

export default function Page() {
  return (
    <DataTable data={data} />
  )
}
